import { styled, css } from "styled-components";

import { colorCSS, fontSizes } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

const tabCSS = css`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("align-self", "stretch")}
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("cursor", "pointer")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("padding", "1.25rem 1rem 1rem")}
    ${redundantCssFromKebab("user-select", "none")}

    &:hover {
        ${redundantCssFromKebab("color", `${colorCSS("B300")}`)}
    }
`;

export const Link = styled.a`
    ${tabCSS}
    ${redundantCssFromKebab("text-decoration", "none")}
`;

export const Tab = styled.button`
    ${tabCSS}
    ${redundantCssFromKebab("border", "0")}
    ${redundantCssFromKebab("background-color", "transparent")}
    ${redundantCssFromKebab("gap", "0.25rem")}

    svg {
        ${redundantCssFromKebab("width", "0.5rem")}
        ${redundantCssFromKebab("height", "auto")}
    }

    &[data-active="true"] {
        ${redundantCssFromKebab("color", `${colorCSS("B300")}`)}
    }
`;

export const TabGroup = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("flex", "1 1 auto")}
`;

export const Underline = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("B300")}`)}
    ${redundantCssFromKebab("bottom", "0")}
    ${redundantCssFromKebab("height", "2px")}
    ${redundantCssFromKebab("position", "absolute")}
    ${redundantCssFromKebab("transition", "left 0.3s ease, width 0.3s ease")}
`;
